<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <custom-tabs v-model="tabs" :tab-items="tabis" grow>
          <template v-slot:helpinfo="{ tab }">
            <help-info
              v-if="tab && tab.value && tab.text"
              :element-name="`${serviceName}-${componentName}-tab-${tab.value}`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="`${tab.text}`"
            />
          </template>
          <template v-slot:staticItems>
            <v-tab-item class="pt-2">
              <v-card flat :disabled="loading">
                <v-progress-linear
                  indeterminate
                  v-if="loading"
                  class="my-2"
                  color="primary"
                ></v-progress-linear>

                <v-row class="pa-2" no-gutters>
                  
                    <v-card                     v-for="(gate, i) in gates"
                    :key="i"

                      rounded="xl"
                      elevation="0"
                      height="80px"
                      style="width: 100%"
                      class="d-flex pa-2 w-100 justify-space-around align-items-center border cursor-pointer"
                      :ripple="false"
                    >
                      <v-avatar style="width: 15%">
                        <!-- <v-icon>{{ gate.icon }}</v-icon> -->
                        <v-img :src="gate.icon" size="50px"></v-img>
                      </v-avatar>
                      <v-card-text
                        style="width: 70%"
                        class="d-flex justify-content-between align-center"
                        @click="
                          setting = true;
                          gateSelect = gate;
                        "
                      >
                        <v-card-text @click="">
                          <v-card-title tag="h1" color="black">
                            <h4 style="color: #32325a">{{ gate.title }}</h4>
                          </v-card-title>
                          <v-card-subtitle style="color: #32325a">{{
                            gate.subtitle
                          }}</v-card-subtitle>
                        </v-card-text>
                        <v-card-actions class="mx-2">
                          <v-icon>mdi-cog</v-icon>
                        </v-card-actions>
                      </v-card-text>

                      <v-card-actions
                        class="d-flex w-15 justify-content-center align-items-center"
                        style="width: 15%"
                      >
                        <v-switch
                          style="margin: 0"
                          v-model="gate.active"
                          @click="
                            gateSelect = gate;
                            update('submit');
                          "
                          color="primary"
                          hide-details
                        >
                          <!-- <template v-slot:label>
                          <span>{{ gate.active ? "فعال" : "غیرفعال" }}</span>
                        </template> -->
                        </v-switch>

                        <v-icon
                          class="mr-3"
                          @click="
                            gateSelect = gate;
                            deleteGate();
                          "
                          >mdi-delete</v-icon
                        >
                      </v-card-actions>
                    </v-card>
                </v-row>

                <v-card-actions>
                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        class="rounded-lg contentinfo w-100"
                        color="green"
                        outlined
                        @click="addGate = true"
                      >
                        <!-- @click="tempGateways.push({ ...temp })" -->
                        <v-icon left>mdi-plus</v-icon>
                        افزودن درگاه
                      </v-btn>
                      <help-info
                        :element-name="`${serviceName}-${componentName}-item-tempGateways`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="افزودن درگاه"
                      />
                    </v-col>
                    <!-- <v-col cols="12" class="pa-2 justify-content-end">
                    <v-btn
                      @click="submitBanner"
                      class=""
                      outlined
                      color="green"
                    >
                      <v-icon>mdi-content-save-check</v-icon>
                      ذخیره تنظیمات
                    </v-btn>
                  </v-col> -->
                  </v-row>
                  <!-- <v-expand-x-transition mode="out-in">
                  <div
                    class="rowinfo"
                    style="width: 100% !important"
                    v-show="!!tempGateways.length || isChanging"
                    :disabled="!canSave && !isChanging"
                  >
                    <v-btn
                      :loading="loading"
                      class="rounded-lg flex contentinfo"
                      color="success"
                      depressed
                      @click="saveGateways"
                    >
                      <v-icon left>mdi-check</v-icon>
                      ذخیره درگاه/ها
                    </v-btn>
                    <help-info
                      :element-name="`${serviceName}-${componentName}-item-saveGateways`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="ذخیره درگاه/ها"
                    />
                  </div>
                </v-expand-x-transition> -->
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-divider class="mb-4" />
            
            <v-card flat>
            <h3 class="text-subtitle-1 mb-0 font-weight-bold">حساب‌های بانکی ثبت شده</h3>
              <div class="px-4 my-5 d-flex align-center justify-space-between rowinfo w-100 flex-column">
              <!-- لیست حساب‌ها -->
              <v-row class="px-2 w-100" v-if="accounts.length > 0">
                <v-col cols="12" md="12" v-for="(account, index) in accounts" :key="'acc-'+index" class="py-1">
                  <!-- پس‌زمینه رنگی بر اساس بانک -->
                  <v-card outlined class="rounded-xl border" :style="{ backgroundColor: getBankInfo(account.card).color }">
                    <div class="d-flex align-center justify-space-between pa-3">
                      
                      <!-- سمت راست: لوگو، اطلاعات کارت و صاحب حساب -->
                      <div class="d-flex align-center ml-4">
                        <v-img 
                          v-if="getBankInfo(account.card).logo" 
                          :src="require(`@/assets/bankLogo/${getBankInfo(account.card).logo}`)" 
                          max-width="28" 
                          class="ml-3"
                          contain
                        ></v-img>
                        <div>
                          <div class="d-flex align-center  mb-1">
                            <span class="text-body-2 font-weight-bold ml-2">{{ getBankInfo(account.card).name }}</span>
                            <span class="text-caption" style="color: #32325a;">( {{ account.name }} )</span>
                          </div>
                          <div class="text-subtitle-2 font-weight-bold" dir="ltr" style="letter-spacing: 1px;">
                            {{ formatCardNumber(account.card) }}
                          </div>
                          <div v-if="account.shaba" class="text-caption mt-1" dir="ltr" style="opacity: 0.7;">
                            IR {{ account.shaba }}
                          </div>
                        </div>
                      </div>

                      <!-- سمت چپ: سوییچ وضعیت و دکمه‌های عملیات -->
                      <div class="d-flex flex-column align-end justify-space-between" style="height: 100%;">
                        <v-switch
                          v-model="account.available"
                          color="primary"
                          dense
                          hide-details
                          class="mt-0 pt-0 mb-2"
                          @change="toggleAccountavailable(account)"
                        ></v-switch>
                        <div class="d-flex">
                          <v-btn icon color="primary" small class="ml-1" @click="openEditCardPopup(account)">
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn icon color="error" small @click="deleteAccount(account.id)">
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </div>

                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <!-- حالت خالی کارت به کارت -->
              <div v-else class="text-center py-10 text--secondary">
                <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-credit-card-off-outline</v-icon>
                <p>هیچ حساب بانکی ثبت نشده است.</p>
              </div>
                <div class="d-flex align-center w-100 mt-2">
                  <v-btn class="rounded-lg contentinfo" color="green" outlined @click="openAddCardPopup" block>
                    <v-icon left>mdi-plus</v-icon>
                    افزودن حساب
                  </v-btn>
                </div>
              </div>

            </v-card>
          </v-tab-item>
          </template>

        </custom-tabs>
            </v-card>
  <custom-popup
        v-model="showCardPopup"
        :cons="{ title: isEditCard ? 'ویرایش حساب بانکی' : 'افزودن حساب بانکی' }"
        maxWidth="500px"
        @action="saveAccount"
      >
        <v-form ref="accountForm" class="pa-4">
          <v-alert
            v-if="cardFormData.card.length >= 6"
            :color="detectedBank.name !== 'بانک نامشخص' ? 'success' : 'warning'"
            outlined
            dense
            class="mb-4 d-flex align-center"
          >
            <div class="d-flex align-center">
              <v-img 
                v-if="detectedBank.logo" 
                :src="require(`@/assets/bankLogo/${detectedBank.logo}`)" 
                max-width="24" 
                class="ml-2"
                contain
              ></v-img>
              بانک تشخیص داده شده: <strong>{{ detectedBank.name }}</strong>
            </div>
          </v-alert>

          <v-text-field
            v-model="cardFormData.card"
            label="شماره کارت"
            placeholder="1234567812345678"
            outlined
            dense
            dir="ltr"
            class="mb-2"
            prepend-inner-icon="mdi-credit-card"
            maxlength="16"
          ></v-text-field>

          <v-text-field
            v-model="cardFormData.name"
            label="نام صاحب حساب"
            placeholder="مثال: علی احمدی"
            outlined
            dense
            class="mb-2"
          ></v-text-field>

          <v-text-field
            v-model="cardFormData.shaba"
            label="شماره شبا (اختیاری)"
            placeholder="123456789012345678901234"
            outlined
            dense
            dir="ltr"
            prefix="IR"
            prepend-inner-icon="mdi-bank"
            maxlength="24"
          ></v-text-field>
        </v-form>
      </custom-popup>
      <!-- select gate -->
      <custom-popup
        maxHeight="500px"
        maxWidth="650px"
        :cons="{ title: 'انتخاب درگاه پرداخت' }"
        v-model="addGate"
      >
        <select-gate
          @fetch="fetch"
          :qr_id="createQrID"
          :loading="loading"
          v-model="gates"
        />
      </custom-popup>
      <!-- change setting -->

      <custom-popup
        v-model="setting"
        :cons="{ title: gateSelect.title }"
        maxWidth="400px"
        minHeight="200px"
        @action="update"
        :disabled="loading"
      >
        <gate-setting v-model="gateSelect" />
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
import customPopup from "../../../../../../core/plugins/TitleRibbon/plugins/popup/customPopup.vue";
import SelectGate from "./gateWays/selectGate.vue";
import gateSetting from "./gateWays/gateSetting.vue";
import { mapGetters } from "vuex";

export default {
  name: "manageGateways",
  components: { customPopup, SelectGate, gateSetting },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "manage-geteways",
    tabs: 0,
    tabis: [
      {
        text: "درگاه پرداخت",
        value: "payment_gateway",
        icon: "credit-card",
      },
      {
        text: "کارت به کارت",
        value: "card_to_card",
        icon: "bank-transfer",
      },
    ],
    current: [],
    loading: false,
    model: true,
    gateways: [],
    tempGateways: [],
    temp: {
      merchant_id: null,
      name: "",
      status: false,
      driver: "default",
    },
    rules: {
      name_count: (v) => v.length > 3 || "حداقل چهار حرف",
    },
    addGate: false,
    gates: [],
    setting: false,
    gateSelect: {},
     accounts: [],
    showCardPopup: false,
    isEditCard: false,
    
    // فرم دیتای کارت
    cardFormData: {
      id: null,
      name: '',
      card: '',
      shaba: '',
      available: true
    },
    
    banksDictionary: {
  '603799': { name: 'ملی', logo: 'Melli.svg', color: '#e3f2fd' },
  '610433': { name: 'ملت', logo: 'Mellat.svg', color: '#ffebee' },
  '603769': { name: 'صادرات', logo: 'Saderat.svg', color: '#e8eaf6' },
  '589210': { name: 'سپه', logo: 'Sepah.svg', color: '#fff3e0' },
  '585983': { name: 'تجارت', logo: 'Tejarat.svg', color: '#e3f2fd' },
  '621986': { name: 'سامان', logo: 'Saman.svg', color: '#e8f5e9' },
  '502229': { name: 'پاسارگاد', logo: 'Pasargad.svg', color: '#fff8e1' },
  '622106': { name: 'پارسیان', logo: 'Parsian.svg', color: '#ffe082' },
  '636214': { name: 'آینده', logo: 'Ayandeh.svg', color: '#e0f2f1' },
  '628023': { name: 'مسکن', logo: 'Maskan.svg', color: '#fff3e0' },
  '603770': { name: 'کشاورزی', logo: 'Keshavarzi.svg', color: '#f1f8e9' },
  '502908': { name: 'توسعه تعاون', logo: 'Tosee_Taavon.svg', color: '#e3f2fd' },
  '627412': { name: 'اقتصاد نوین', logo: 'Eghtesad_Novin.svg', color: '#f3e5f5' },
  '627381': { name: 'انصار', logo: 'Ansar.svg', color: '#fff8e1' },
  '502806': { name: 'شهر', logo: 'Shahr.svg', color: '#ffebee' },
  '502938': { name: 'دی', logo: 'Dey.svg', color: '#e0f2f1' },
  '606373': { name: 'قوامین', logo: 'Ghavamin.svg', color: '#e8f5e9' },

  '627488': { name: 'کارآفرین', logo: 'Karafarin.svg', color: '#fce4ec' },
  '505416': { name: 'مهر اقتصاد', logo: 'Mehr_Eghtesad.svg', color: '#f3e5f5' },
  '505801': { name: 'کوثر', logo: 'Kosar.svg', color: '#e0f2f1' },
  '627760': { name: 'ایران زمین', logo: 'Iran_Zamin.svg', color: '#fff3e0' },
  '505426': { name: 'ملی ایران', logo: 'Melli.svg', color: '#e3f2fd' },
  '639607': { name: 'صنعت و معدن', logo: 'Sanat_Madan.svg', color: '#e8eaf6' },
  '627353': { name: 'سرمایه', logo: 'Sarmayeh.svg', color: '#fff8e1' },
  '627961': { name: 'صنعت و تجارت', logo: 'Tejarat.svg', color: '#e3f2fd' },
  '505448': { name: 'رسالت', logo: 'Resalat.svg', color: '#f1f8e9' },
  '505426': { name: 'رفاه', logo: 'Refah.svg', color: '#ffebee' },
  '627816': { name: 'سینا', logo: 'Sina.svg', color: '#e0f2f1' },
  '505430': { name: 'توسعه', logo: 'Tosee.svg', color: '#fff3e0' },
  '627488': { name: 'کارآفرین', logo: 'Karafarin.svg', color: '#fce4ec' },
  '636795': { name: 'مهر ایرانیان', logo: 'Mehr_Iran.svg', color: '#f3e5f5' },
  '505801': { name: 'کوثر', logo: 'Kosar.svg', color: '#e0f2f1' },
  '505806': { name: 'نور', logo: 'Noor.svg', color: '#e8f5e9' },

  'Bank_Markazi': { name: 'مرکزی', logo: 'Bank_Markazi.svg', color: '#e3f2fd' },
  'Caspian': { name: 'کاسپین', logo: 'Caspian.svg', color: '#fff8e1' },
  'Futurebank': { name: 'فیوچر بانک', logo: 'Futurebank.svg', color: '#e0f2f1' },
  'Gardeshgari': { name: 'گردشگری', logo: 'Gardeshgari.svg', color: '#fff3e0' },
  'Hekmat': { name: 'حکمت', logo: 'Hekmat.svg', color: '#f1f8e9' },
  'Iran_Europe': { name: 'ایران اروپا', logo: 'Iran_Europe.svg', color: '#e8eaf6' },
  'Iran_Venezuela': { name: 'ایران ونزوئلا', logo: 'Iran_Venezuela.svg', color: '#ffebee' },
  'Khavar_Mianeh': { name: 'خاورمیانه', logo: 'Khavar_Mianeh.svg', color: '#fff8e1' },
  'Melall': { name: 'ملل', logo: 'Melall.svg', color: '#e3f2fd' },
  'Postbank': { name: 'پست بانک', logo: 'Postbank.svg', color: '#ffebee' },
  'Standard_Chartered': { name: 'استاندارد چارترد', logo: 'Standard_Chartered.svg', color: '#e0f2f1' },
  'Taavon_Eslami': { name: 'تعاون اسلامی', logo: 'Taavon_Eslami.svg', color: '#f1f8e9' },
  'Tosee_Saderat': { name: 'توسعه صادرات', logo: 'Tosee_Saderat.svg', color: '#e8eaf6' }
}
  }),

  mounted() {
    this.fetch();
    this.fetchAccounts();

  },

  computed: {
    ...mapGetters("localstorage",['createQrID']),
    detectedBank() {
      if (this.cardFormData.card && this.cardFormData.card.length >= 6) {
        const prefix = this.cardFormData.card.substring(0, 6);
        return this.banksDictionary[prefix] || { name: 'بانک نامشخص', logo: null, color: '#ffffff' };
      }
      return { name: '', logo: null, color: '#ffffff' };
    },
    canSave() {

      const _this = this;

      return this.computedGateways.every(
        (item, index, arr) =>
          !!item.merchant_id &&
          !_this.computedGateways
            .filter((g, j) => index !== j)
            .map((g) => g.merchant_id)
            .includes(item.merchant_id) &&
          !!item.name &&
          item.name?.length > 3
      );
    },
    computedGateways: {
      get() {
        return [...this.gateways, ...this.tempGateways];
      },
      set(val) {
        console.log("val: ", val);
      },
    },
    isChanging() {
      const _this = this;
      return this.current.some((item, index) => {
        let { merchant_id, name, driver, status } = _this.gateways[index];

        return (
          item.merchant_id !== merchant_id ||
          item.name !== name ||
          item.driver !== driver ||
          item.status !== status
        );
      });
    },
  },

  watch: {
    computedGateways(val) {
      this.getState(false);
    },
  },

    methods: {
    async fetchAccounts() {
      try {
        let response = await this.$api.get(`v1/testQr/card?qr_id=${this.createQrID}`);
        if (response.status === 200) {
          this.accounts = response.data.data;
        }
      } catch (err) {
        const errorMsg = err.response?.data?.message || "خطا در دریافت لیست حساب‌های بانکی";
        this.$toast.error(errorMsg);
      }
    },

    openAddCardPopup() {
      this.isEditCard = false;
      this.cardFormData = {
        id: null,
        name: "",
        card: "",
        shaba: "",
        available: true,
      };
      this.showCardPopup = true;
    },

    openEditCardPopup(account) {
      this.isEditCard = true;
      this.cardFormData = { ...account };
      this.showCardPopup = true;
    },

    async saveAccount() {
      if (!this.cardFormData.card || !this.cardFormData.name) {
        this.$toast.warning("لطفا اطلاعات ضروری را تکمیل کنید");
        return;
      }

      try {
        await this.$api.post("v1/testQr/storeCard", {
          card: this.cardFormData.card,
          shaba: this.cardFormData.shaba,
          name: this.cardFormData.name,
          available: this.cardFormData.available,
          qr_id: this.createQrID,
        });

        this.$toast.success("حساب بانکی با موفقیت ذخیره شد");
        this.showCardPopup = false;
        this.fetchAccounts(); 
      } catch (err) {
        const errorMsg = err.response?.data?.message || "خطا در ذخیره حساب بانکی";
        this.$toast.error(errorMsg);
        this.showCardPopup = false;

      }
    },

    async deleteAccount(id) {
      if (await this.$modal.yesNo(`آیا از حذف این حساب بانکی خود اطمینان دارید؟`)) {
        try {
          await this.$api.delete(`/v1/testQr/deleteCard/${this.createQrID}/${id}`);
          this.$toast.success("حساب بانکی با موفقیت حذف شد");
          this.fetchAccounts(); // به‌روزرسانی لیست
        } catch (err) {
          const errorMsg = err.response?.data?.message || "خطا در حذف حساب بانکی";
          this.$toast.error(errorMsg);
        }
      }
    },

    async toggleAccountavailable(account) {
      try {
        await this.$api.post("v1/testQr/storeCard", {
          card: account.card,
          shaba: account.shaba,
          name: account.name,
          available: account.available,
          qr_id: this.createQrID,
        });
        this.$toast.success("وضعیت حساب بانکی تغییر یافت");
      } catch (err) {
        account.available = !account.available;
        const errorMsg = err.response?.data?.message || "خطا در تغییر وضعیت حساب بانکی";
        this.$toast.error(errorMsg);
      }
    },

    getBankInfo(cardNumber) {
      if (cardNumber && cardNumber.length >= 6) {
        const prefix = cardNumber.substring(0, 6);
        return (
          this.banksDictionary[prefix] || {
            name: "بانک نامشخص",
            logo: null,
            color: "#ffffff",
          }
        );
      }
      return { name: "بانک نامشخص", logo: null, color: "#ffffff" };
    },

    formatCardNumber(number) {
      if (!number) return "";
      return number.toString().replace(/\d{4}(?=.)/g, "$& - ");
    },

    async fetch() {
      this.loading = true;
      try {
        const { data } = await this.$api.get(`/v1/gate-way/qr/${this.createQrID}`);
        let input = data.data;
        let gateFetch = [];
        input.map((item) => {
          gateFetch.push({
            title: item.gateway.title,
            subtitle: item.gateway.subtitle,
            config: item.config,
            id: item.gateway.id,
            icon: item.gateway.icon,
            link: item.gateway.link,
            active: item.active,
          });
        });
        this.gates = gateFetch;
      } catch (err) {
        const errorMsg = err.response?.data?.message || "مشکلی در دریافت درگاه‌ها پیش آمده است";
        this.$toast.error(errorMsg);
      } finally {
        this.loading = false;
      }
    },

    async update(e) {
      if (e == "submit") {
        this.loading = true;
        try {
          await this.$api.put(
            `/v1/gate-way/qr/update/${this.gateSelect.id}/${this.createQrID}`,
            this.gateSelect
          );
          this.$toast.success("درگاه پرداخت شما با موفقیت ویرایش شد");
          this.setting = false;
          this.fetch();
        } catch (err) {
          this.fetch();
          const errorMsg = err.response?.data?.message || "مشکلی در ویرایش درگاه پیش آمده است";
          this.$toast.error(errorMsg);
        } finally {
          this.loading = false;
        }
      }
    },

    async deleteGate() {
      if (await this.$modal.yesNo(`آیا از حذف درگاه خود اطمینان دارید؟`)) {
        this.loading = true;
        try {
          await this.$api.delete(
            `/v1/gate-way/qr/delete/${this.gateSelect.id}/${this.createQrID}`
          );
          this.$toast.success("درگاه با موفقیت حذف شد");
          this.fetch();
        } catch (err) {
          const errorMsg = err.response?.data?.message || "مشکلی در حذف درگاه پیش آمده است";
          this.$toast.error(errorMsg);
        } finally {
          this.loading = false;
        }
      }
    },

    getState(msg = true) {
      if (!this.computedGateways.length)
        this.$nextTick(() => {
          this.model = true;
        });
      else
        this.$nextTick(() => {
          this.model = false;
          if (msg) this.$toast.info("پرداخت از طریق درگاه شخصی.");
        });
    },

    async saveGateways() {
      this.loading = true;
      try {
        const { data } = await this.$api.post("/v1/testQr/user_gateways", this.computedGateways);
        this.current = [...data.data];
        this.gateways = data.data;
        this.tempGateways = [];
        this.$toast.success("درگاه‌ها با موفقیت ذخیره شدند");
      } catch (err) {
        const errorMsg = err.response?.data?.message || "مشکلی در افزودن درگاه‌ها پیش آمده است";
        this.$toast.error(errorMsg);
      } finally {
        this.loading = false;
      }
    },

    changeGateSetting(e) {
      if (e == "submit") {
        this.$toast.success("مقادیر جدید افزوده شد");
        this.gateSelect = {};
      } else {
        this.gateSelect = {};
      }
    },
  },

};
</script>

<style scoped></style>
